import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inbox-dropdown',
  templateUrl: './inbox-dropdown.component.html',
  styleUrls: ['./inbox-dropdown.component.scss']
})
export class InboxDropdownComponent implements OnInit {
  //TODO
  constructor() { }

  ngOnInit() {
  }

}
